var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.0605469L7.50781 0.904297L0.757812 12.5938L0.283203 13.4375H15.7168L15.2422 12.5938L8.49219 0.904297L8 0.0605469ZM8 2.31055L13.7656 12.3125H2.23438L8 2.31055ZM7.4375 6.125V9.5H8.5625V6.125H7.4375ZM7.4375 10.0625V11.1875H8.5625V10.0625H7.4375Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warning-sign.7b63ee1c6ac5386413b385c8c5f9955d.svg";
export { ForwardRef as ReactComponent };